import { isEmpty } from "lodash-es";
import { Fragments } from "requests";
import {
  DIAGNOSIS_KEYS,
  MEASUREMENT_KEYS,
  TOOTH_DIAGNOSIS_LABELS
} from "./constants";
import { TeethData, ToothData } from "./types";

export const getAllTeethData = (
  dentalChartings: Fragments.StoredDentalChartings
): TeethData => {
  return (
    dentalChartings?.reduce((data, tooth) => {
      const toothData = {} as ToothData;

      MEASUREMENT_KEYS.forEach(key => {
        if (tooth[key]) {
          toothData[key] = `${tooth[key]} mm`;
        }
      });

      DIAGNOSIS_KEYS.forEach(key => {
        const diagnosis = tooth[key];
        if (diagnosis) {
          toothData[key] = TOOTH_DIAGNOSIS_LABELS[diagnosis];
        }
      });

      if (toothData.other?.length) {
        toothData.other = tooth.other
          .map(other => TOOTH_DIAGNOSIS_LABELS[other])
          .join(", ");
      }

      if (isEmpty(toothData)) {
        return data;
      }

      return {
        ...data,
        [tooth.tooth]: { ...toothData, toothState: tooth.toothState }
      };
    }, {}) || {}
  );
};
